module.exports = __webpack_public_path__ + "static/img/bg-1.6224f311.png";